<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <p class="f16">指定商品手续费比例调整</p>

    <div class="upload-container mt20">
      <div class="upload-btn">
        <el-button type="primary" icon="el-icon-upload" plain>添加角标</el-button>
        <input @change="(e) => changeFile(e, 1)" accept=".jpg,.jpeg,.png" type="file" />
      </div>
    </div>
    <table class="table">
      <tr>
        <th class="w300">角标</th>
        <th class="w230">手续费比例</th>
        <th></th>
      </tr>
      <tr v-for="(item, index) in form.sellerTagVOList" :key="index">
        <td><img class="tag-img" :src="item.tagUrl" alt=""></td>
        <td>
          <el-input placeholder="0~10" v-model="item.tagCode" @input="(val) => inputNumber(val, index)" style="width: 200px">
            <i slot="suffix" class="el-input__icon">%</i>
          </el-input>
        </td>
        <td>
          <el-button type="text" @click="removeTag(index)">删除</el-button>
        </td>
      </tr>
      <tr v-if="form.sellerTagVOList.length === 0">
        <td colspan="2" class="gray">请添加角标</td>
      </tr>
    </table>

    <p class="mt20 mb10">SPU导入</p>
    <div class="upload-container">
      <div class="upload-btn">
        <el-button type="primary" icon="el-icon-upload" plain>点击上传</el-button>
        <input @change="(e) => changeFile(e, 2)" accept=".xls,.xlsx" type="file" />
      </div>
      <!-- <el-button type="text" @click="downloadTemplate">下载文件模板</el-button> -->
    </div>
    <p class="mt10 gray">只能上传.xls .xlsx</p>
    <template v-if="form.fileName">
      <div class="file-item bg-gray"><i class="el-icon-document"></i> {{ form.fileName }}</div>
      <el-button class="ml20" type="text" size="mini" @click="downloadFile(form.fileUrl)">下载</el-button>
    </template>

    <div class="mt20">
      <el-button type="primary" @click="submitUpload">保存生效</el-button>
    </div>

    <el-dialog title="保存失败" :visible.sync="dialogVisible" width="400px">
      <p v-if="uploadResultFileUrl"><el-link type="primary" @click="downloadResultFile">下载文件解析结果</el-link>（请根据错误原因更新文件后重新提交）</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Client from "@/utils/client.js";
import { downloadUrlFile } from '@/utils/functions';
import { fileUpload } from '../../api/merchants';
import {
  saveSellerSearchTop,
  getSellerSearchTop,
  queryImageInfo,
} from './api';

export default {
  data() {
    return {
      fullscreenLoading: false,
      form: {
        fileUrl: null,
        fileName: null,
        sellerTagVOList: [],
      },
      dialogVisible: false,
      uploadResultFileUrl: null,
    };
  },
  mounted() {
    this.getSellerSearchTop();
  },
  methods: {
    getSellerSearchTop() {
      getSellerSearchTop().then(res => {
        if (res.data && res.data.success) {
          res.data.data.sellerTagVOList = res.data.data.sellerTagVOList || [];
          this.form = res.data.data;
        } else {
          this.$message.error(res.data.message || '系统异常，请稍后再试');
        }
      })
    },
    inputNumber(val, index) {
      // 替换掉数字和小数点 . 之外的字符
      val = val.replace(/[^\d.]/g, '');
      // 把2个以上的小数点 . 替换成一个小数点 .
      val = val.replace(/\.{2,}/g, '.');
      // 保证第一个字符为数字而不是小数点 .
      val = val.replace(/^\./g, '');
      // 保证小数点 . 只出现一次，而不能出现两次以上
      val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
      // 只能输入两个小数
      // val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      if (val > 10) {
        val = 10;
      }
      this.form.sellerTagVOList[index].tagCode = val;
    },
    async changeFile(e, type) {
      if (e && e.target && e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        if (type === 1 && !/\.(png|jpe?g)(\?.*)?$/.test(String(file.name).toLowerCase())) {
          this.$message.error('只能上传.jpg .jpeg .png格式');
          return;
        }
        if (type === 2 && !/\.xlsx?$/.test(String(file.name).toLowerCase())) {
          this.$message.error('只能上传.xls .xlsx格式');
          return;
        }
        if (file.size > 50 * 1024 * 1024) {
          this.$message.error('文件太大了');
          return;
        }
        this.fullscreenLoading = true;
        const confRes = await fileUpload();
        const OSSClient = Client(confRes.data.data);
        const fileName = this.random_string(6) + '_' + new Date().getTime() + '.' + file.name.split('.').pop();
        const random_name = 'tmp/' + fileName;
        const res = await OSSClient.put(random_name, file);
        if (type === 1) {
          const resInfo = await queryImageInfo(res.url);
          if (resInfo.data && resInfo.data.ImageWidth) {
            this.form.sellerTagVOList.push({
              tagCode: null,
              tagUrl: res.url,
              tagWidth: resInfo.data.ImageWidth.value,
              tagHeight: resInfo.data.ImageHeight.value,
            });
          }
        } else {
          this.form.fileUrl = res.url;
          this.form.fileName = file.name.substring(file.name.lastIndexOf('/'));
        }
        this.fullscreenLoading = false;
      }
      e.target.value = '';
    },
    random_string(len) {
      len = len || 32;
      let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678', maxPos = chars.length, pwd = '';
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    removeTag(index) {
      this.form.sellerTagVOList.splice(index, 1);
    },
    submitUpload() {
      if (this.form.sellerTagVOList.length === 0) {
        this.$message('请上传角标图片');
        return;
      }
      if (this.form.sellerTagVOList.some(item => (!item.tagCode || item.tagCode == 0))) {
        this.$message('请输入手续费比例');
        return;
      }
      if (!this.form.fileUrl) {
        this.$message('请上传SPU导入文件');
        return;
      }
      this.uploadResultFileUrl = null;
      this.$confirm(`确认信息无误？`, '确认', {
        confirmButtonText: '提交',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true;
        saveSellerSearchTop(this.form).then((res) => {
          if (res.data && res.data.success) {
            if (res.data.code === '1001') {
              this.uploadResultFileUrl = res.data.data;
              this.dialogVisible = true;
            } else {
              this.$message.success('保存成功');
              this.getSellerSearchTop();
            }
          } else {
            this.$message.error(res.data.message || '系统异常，请稍后再试');
          }
          this.fullscreenLoading = false;
        }).catch(() => {
          this.fullscreenLoading = false;
        });
      }).catch(() => {});
    },
    downloadTemplate() {
    },
    downloadFile(url) {
      downloadUrlFile(url);
    },
    downloadResultFile() {
      this.downloadFile(this.uploadResultFileUrl);
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
  font-size: 14px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.ml20 {
  margin-left: 20px;
}
.mt10 {
  margin-top: 10px;
}
.mt20 {
  margin-top: 20px;
}
.mb10 {
  margin-bottom: 10px;
}
.gray {
  color: #939da9;
}
.bg-gray {
  background-color: #f2f2f2;
}
.f16 {
  font-size: 16px;
}
.upload-container {
  display: flex;

  .upload-btn {
    position: relative;
    margin-right: 50px;

    input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
}
.table {
  margin-top: 10px;
  border-spacing: 0;
  border-collapse: collapse;
  text-align: left;
  td,th {
    padding: 5px 0;
  }
  .w300 {
    width: 300px;
  }
  .w230 {
    width: 230px;
  }
}
.file-item {
  display: inline-block;
  padding: 5px 10px;
  margin-top: 10px;
  border-radius: 4px;
}
.tag-img {
  display: block;
  max-width: 200px;
}
</style>
